import { ReactNode } from 'react'
import { clsx } from 'clsx'
import { PencilIcon } from './icons'

export function PageGroupRows({ children }: { children: ReactNode }) {
  return <div className="divide-y divide-stone-100">{children}</div>
}

type PageGroupRowProps = {
  title: string
  pageLabel: string
  description?: ReactNode
  renderEditor?: () => ReactNode
  selected?: boolean
  editing?: boolean
  onEdit?: () => void
  onClickJump: () => void
  onToggleSelected?: () => void
}
export function PageGroupRow({
  title,
  pageLabel,
  description,
  renderEditor,
  selected,
  editing,
  onEdit,
  onClickJump,
  onToggleSelected
}: PageGroupRowProps) {
  return (
    <div
      className={clsx('group/row px-3 py-2', {
        'bg-blue-100': editing || selected,
        'bg-white hover:bg-stone-50': !editing && !selected
      })}
    >
      <div className="relative flex items-start gap-2">
        <button
          type="button"
          aria-label={`Go to ${pageLabel}`}
          className="absolute -inset-x-3 -inset-y-2 cursor-pointer rounded-sm"
          onClick={onClickJump}
        />
        {onToggleSelected && (
          <input
            aria-label={`Select ${pageLabel}`}
            type="checkbox"
            className="relative z-10 mt-0.5"
            checked={selected}
            onChange={onToggleSelected}
          />
        )}
        <span className="pointer-events-none relative shrink-0 text-sm font-medium text-stone-800">
          {pageLabel}
        </span>
        <div className="pointer-events-none relative flex min-w-0 flex-1 items-start justify-end gap-1 text-right text-sm text-stone-500">
          {onEdit && !editing && (
            <button
              type="button"
              aria-label={`Edit ${pageLabel}`}
              aria-expanded={editing}
              onClick={onEdit}
              className="pointer-events-auto relative z-10 shrink-0 p-0.5 text-stone-500 opacity-0 hover:text-blue-600 group-focus-within/row:opacity-100 group-hover/row:opacity-100 [@media(hover:none)]:opacity-100"
            >
              <PencilIcon className="h-3.5 w-3.5" />
            </button>
          )}
          <span className="min-w-0 break-words">{title}</span>
        </div>
      </div>
      {description && <div className="mt-1 break-words text-xs text-stone-500">{description}</div>}
      {editing && renderEditor?.()}
    </div>
  )
}
